/* eslint-disable prefer-template */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { BrandBanner } from "./BrandBanner";
import { BrandDownload } from "./BrandDownload";

const Brand = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <BrandBanner />
      <BrandDownload />
    </div>
  );
};
export default Brand;
